import React from "react";
import { Link } from "react-router-dom";

/**
 * Renders a react-router <Link> for internal paths (starts with "/") or a
 * plain <a> (opens new tab) for absolute http(s) URLs. Used for CMS-driven
 * button targets where admins may type either an internal path or an
 * external URL.
 */
export function SmartLink({ to, children, ...rest }) {
  const target = to || "/";
  const isExternal = /^https?:\/\//i.test(target);
  if (isExternal) {
    return (
      <a href={target} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={target} {...rest}>
      {children}
    </Link>
  );
}
